import { useState } from "react";

export default function ShareBar({ title }: { title: string }) {
  const [toast, setToast] = useState("");

  const copyLink = async () => {
    const url = window.location.href;
    try {
      await navigator.clipboard.writeText(url);
    } catch {
      const input = document.createElement("input");
      input.value = url;
      document.body.appendChild(input);
      input.select();
      document.execCommand("copy");
      document.body.removeChild(input);
    }
    showToast("链接已复制到剪贴板");
  };

  const showToast = (msg: string) => {
    setToast(msg);
    window.setTimeout(() => setToast(""), 2200);
  };

  const shareMock = (name: string) => {
    showToast(`已生成${name}分享内容（模拟分享，未接入第三方 SDK）`);
  };

  return (
    <div className="relative flex flex-wrap items-center gap-2">
      <span className="mr-1 text-sm text-foreground-500">分享：</span>
      <button
        type="button"
        onClick={copyLink}
        className="flex items-center gap-1.5 rounded-md border border-background-200 px-3 py-1.5 text-sm text-foreground-700 transition-colors hover:border-primary-400 hover:text-primary-400"
      >
        <i className="ri-link"></i>复制链接
      </button>
      {[
        { name: "微博", icon: "ri-weibo-fill" },
        { name: "微信", icon: "ri-wechat-fill" },
        { name: "抖音", icon: "ri-tiktok-fill" },
      ].map((s) => (
        <button
          key={s.name}
          type="button"
          onClick={() => shareMock(s.name)}
          className="flex h-8 w-8 items-center justify-center rounded-md border border-background-200 text-foreground-600 transition-colors hover:border-accent-400 hover:text-accent-400"
          aria-label={`分享到${s.name}`}
          title={`分享到${s.name}`}
        >
          <i className={s.icon}></i>
        </button>
      ))}

      {toast && (
        <div className="fixed bottom-24 left-1/2 z-[70] -translate-x-1/2 rounded-md bg-foreground-950 px-4 py-2.5 text-sm text-background-50 md:bottom-10">
          <span className="flex items-center gap-2">
            <i className="ri-checkbox-circle-fill text-accent-400"></i>
            {toast}
          </span>
        </div>
      )}
      <span className="sr-only">{title}</span>
    </div>
  );
}